/**
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
 */

import { AeroModule } from 'src/aero/aero.module';
import { CommonModule } from '@angular/common';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { GettingStartedTemplatesDialogComponent } from './getting-started-templates-dialog.component';

/**
 * Module hosting the getting started template invite dialog.
 */
@NgModule({
  declarations: [
    GettingStartedTemplatesDialogComponent,
  ],
  imports: [
    AeroModule,
    CommonModule,
    DynamicDialogModule,
    SVGIconModule,
    TranslocoModule,
    FormsModule,
  ],
})
export class GettingStartedTemplatesModule { }
